import httpStore from "@/api/httpStore.js";

export function sendCustomerToEscala(customerId) {
  return httpStore
    .post(`/escala`, { customerId })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function sendAllCustomersToEscala() {
  return httpStore
    .post(`/escala/all`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
